import React from "react";
import { Link } from "react-router-dom";
import Buttons from "./Buttons";
import Fade from "react-reveal/Fade";

const desc = {
  margin: "0",
  fontSize: "14px",
  padding: "5px 0",
};
const title = {
  fontSize: "24px",
  margin: "0",
  textDecoration: "underline",
};

const textCol = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "300px",
  margin: "0 38px"
};

const LandingRight = ({ image, text, obj, links, toWhere }) => {
  return (
    <Fade right fraction={0.3} duration={1500} distance={"120px"}>
      <div
        className="padded ui stackable grid"
        style={{ display: "flex", justifyContent: "space-evenly" }}
      >
        <div className="row" style={{ maxWidth: "800px" }}>
          <div className="center aligned left" style={textCol}>
            <h4 style={title}>{obj.title}</h4>
            <h6 style={desc}>{obj.desc}</h6>
            <p>{obj.dl}</p>
            <Link to={toWhere}>View More</Link>
            <Buttons links={links} />
          </div>

          <div style={{ margin: "30px 38px", width: "300px" }} className="right">
            <img
              src={image}
              alt={text}
              className="ui medium rounded image centered"
              width={"250px"}
            />
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default LandingRight;
